import builder from '../builder';
import RouterSignal1 from '../../streamline-icons/bold/router-signal-1.svg';

export default builder('IconRouterSignal1Bold', RouterSignal1);
